// extracted by mini-css-extract-plugin
export default {"root":"_61kbF","link-overlay":"_37oD3","linkOverlay":"_37oD3"};